import React from 'react';
import { createSvgIcon } from '../../icon';
/* eslint-disable max-len */
export default createSvgIcon('check-1', '0 0 96 96', React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M87.5 12.2L30.9 68.7 8.6 46.4 1 54l29.9 29.8L95 19.7z" })));
